module.exports = __webpack_public_path__ + "static/media/trainers-logo.6ff55871.png";